import { globalAuth } from '@common/application/utils/auth';
import { isGuest } from '@common/application/utils/is-guest';
import { render, unmount } from '@common/application/utils/render';
import { Modal } from '@common/components/common/modal';

import { LoginAndRegisterModal } from '@/components/common/login-and-register-modal';

interface Props {
  onSuccess?: () => void;
  onCancel?: () => void;
}

interface LoginByModal {
  (options?: Props): Promise<boolean>;
  check: typeof checkWithLogin;
}

export const loginByModal = ((options) => {
  return new Promise((resolve) => {
    const container = document.createDocumentFragment();
    const handleSuccess = () => {
      unmount(container);
      options?.onSuccess?.();
      resolve(true);
    };
    const handleCancel = () => {
      unmount(container);
      options?.onCancel?.();
      resolve(false);
    };
    render(
      <Modal
        style={{ width: '392px' }}
        open
        destroyHeader
        destroyFooter
        destroyCloseIcon
        maskCancelable
        onCancel={handleCancel}
        getContainer={() => document.body}
      >
        <LoginAndRegisterModal onSuccess={handleSuccess} onNavigate={handleCancel} />
      </Modal>,
      container
    );
  });
}) as LoginByModal;

function checkWithLogin(): boolean {
  if (isGuest()) {
    globalAuth.login();
    return false;
  }
  return true;
}

loginByModal.check = checkWithLogin;
